import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { PERMISSION_KEYS } from '../config/permissions'
import { loadingClass } from '../lib/ui'

/** Доступ к графику производства и связанным экранам планирования. */
export function RequireProductionScheduleAccess({ children }: { children: ReactNode }) {
  const { can, loading } = useAuth()

  if (loading) {
    return (
      <div className={loadingClass}>
        <p>Загрузка…</p>
      </div>
    )
  }

  if (!can(PERMISSION_KEYS.PRODUCTION_SCHEDULE_READ)) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
